// Config.
import filterSourceOfFundsOptions from '@/config/filter-source-of-funds-options';
import sourcesOfFunds from '@/config/sources-of-funds';

// Services.
import getOptions from './get-options';

/**
 * Returns an array of objects describing source of funds filters.
 * @param {number} tab - The active tab.
 * @returns {Array} An array of objects describing filters.
 */
const getSourceOfFundsOptions = (tab) => getOptions(
  tab,
  sourcesOfFunds,
  filterSourceOfFundsOptions,
);

export default getSourceOfFundsOptions;
